import { fromJS } from 'immutable';
import _ from 'lodash';

require('es6-promise').polyfill();
require('isomorphic-fetch');

String.prototype.capitalizeFirstLetter = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

export const getActionType = (namespace, endpoint, type) => {
    return namespace.toUpperCase() + '_' + endpoint.toUpperCase() + '_' + type;
};

export function isString(o) {
    return typeof o === 'string' || (typeof o === 'object' && o.constructor === String);
}

export const generateHeader = token => {
    return {
        'access-token': token.token,
        expiry: token.expiry,
        uid: token.uid,
        'token-type': 'Bearer',
        client: token.client,
    };
};

export const parseJSON = response => {
    return response.json();
};

export const parseBLOB = response => {
    return response.blob();
};

export const parseEndpoint = (endpoint, args) => {
    let parsedEndpoints = endpoint;
    for (const arg in args) {
        if (isString(arg)) {
            parsedEndpoints = parsedEndpoints.replace(':' + arg, args[arg]);
        }
    }
    return parsedEndpoints;
};

export const extractKeys = object => {
    const endPointMap = fromJS(object);
    return endPointMap.keySeq().filter(prop => {
        return object.hasOwnProperty(prop);
    });
};

export const requestPromise = (getConf, endpoint) => {
    return _args => {
        const args = _args || {};

        const conf = getConf();
        const requestParams = endpoint.request;
        const paramsToExtract = ['credentials', 'headers', 'method'];

        let endpointPrefix = args.endpointPrefix || conf['endpointPrefix'] || '';
        if (endpointPrefix !== '') {
            endpointPrefix = '/' + endpointPrefix;
        }

        const confParams = _.pick(Object.assign(conf, {}, requestParams), paramsToExtract);
        const constructedFetchParams = _(_.pick(requestParams, paramsToExtract)).merge(confParams);
        const headers = _.get(constructedFetchParams.value(), 'headers');
        const token = _.get(args, ['token']);

        var totalParams = constructedFetchParams;

        if (token) {
            const newHeaders = _(headers).merge(generateHeader(token));
            if (newHeaders) {
                totalParams = totalParams.merge({ headers: newHeaders.value() }).value();
            }
        } else {
            totalParams = totalParams.merge({ headers: headers }).value();
        }

        if (totalParams.method !== 'GET') {
            if (args.data) {
                const headers = _.omit(totalParams.headers, ['Content-Type', 'Accept']);
                totalParams = _(totalParams)
                    .omit(['headers'])
                    .merge({
                        body: args.data,
                        headers: headers,
                    })
                    .value();
            } else {
                totalParams = _(totalParams)
                    .merge({
                        body: JSON.stringify(_.pick(args, requestParams.body)),
                    })
                    .value();
            }
        }

        const url = conf.root + endpointPrefix + parseEndpoint(requestParams.endpoint, args);
        const fetchPromise = fetch(url, totalParams);
        const responseHanlder = endpoint.response.transform;
        const promises = _.reduce(
            responseHanlder,
            function(total, n) {
                return total.then(n);
            },
            fetchPromise
        );
        return promises;
    };
};
